import { motion } from "framer-motion";

// Masked line-by-line reveal — split a heading into <span> lines and pass as children arrays.
export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className="mask-line inline-block align-baseline">
    <motion.span
      className={`inline-block ${className}`}
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.05, delay, ease: [0.65, 0, 0.35, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

// Scroll-triggered fade + rise
export const RiseIn = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

// Split-text word-by-word reveal
export const SplitWords = ({ text, className = "", delay = 0, stagger = 0.05 }) => {
  const words = text.split(" ");
  return (
    <span className={className}>
      {words.map((w, i) => (
        <span key={i} className="mask-line inline-block whitespace-pre">
          <motion.span
            className="inline-block"
            initial={{ y: "110%" }}
            whileInView={{ y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{
              duration: 0.9,
              delay: delay + i * stagger,
              ease: [0.65, 0, 0.35, 1],
            }}
          >
            {w}
            {i < words.length - 1 ? "\u00A0" : ""}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
